var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4005",
    "data-name": "Rectangle 4005",
    width: 24,
    height: 24,
    transform: "translate(-11943 -3048)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_",
    "data-name": "Search ",
    transform: "translate(11943 3048)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7652",
    "data-name": "Group 7652",
    transform: "translate(-11939.235 -3044.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6732",
    "data-name": "Group 6732",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7399",
    "data-name": "Path 7399",
    d: "M13.354,6.886A6.469,6.469,0,1,1,6.885.417a6.468,6.468,0,0,1,6.469,6.469",
    transform: "translate(-0.18 -0.181)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7400",
    "data-name": "Path 7400",
    d: "M13.354,6.886A6.469,6.469,0,1,1,6.885.417,6.468,6.468,0,0,1,13.354,6.886Z",
    transform: "translate(-0.18 -0.181)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_536",
    "data-name": "Line 536",
    x2: 4.097,
    y2: 4.097,
    transform: "translate(11.233 11.377)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.90c7972b4d334cc99457f14295472a85.svg";
export { ForwardRef as ReactComponent };